import { createSlice } from "@reduxjs/toolkit";

const initialTargetState = {
  listLoading: false,
  actionsLoading: false,
  totalCount: 0,
  entities: null,
  meta: {total : 0},
  links: null,
  aggregationEntities: null,
  pageEntities: null,
  lastError: null,
  targetForEdit: undefined,
};

export const callTypes = {
  list: "list",
  action: "action",
};

export const targetSlice = createSlice({
  name: "target",
  initialState: initialTargetState,
  reducers: {
		catchError: (state, action) => {
      state.error = `${action.type}: ${action.payload.error}`;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = false;
      } else {
        state.actionsLoading = false;
      }
    },
    startCall: (state, action) => {
      state.error = null;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = true;
      } else {
        state.actionsLoading = true;
      }
    },
		targetFetched: (state, action) => {
      const { entities, meta, links } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.entities = entities;
      state.meta = meta;
      state.links = links;
    },
		targetAllFetched: (state, action) => {
      const { totalCount, entities } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.aggregationEntities = entities;
      state.totalCount = totalCount;
    },
		targetPageFetched: (state, action) => {
      const { totalCount, entities } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.pageEntities = entities;
      state.totalCount = totalCount;
    },
    targetCreated: (state, action) => {
      state.actionsLoading = false;
      state.error = null;
      state.pageEntities.target.push(action.payload.target);
    },
    targetDeleted: (state, action) => {
      state.error = null;
      state.actionsLoading = false;
      state.pageEntities = state.pageEntities.target.filter(el => el.target_id !== action.payload.id);
    },
    getTarget: (state, action) => {
      state.actionsLoading = false;
      state.targetForEdit = action.payload.targetForEdit;
      state.error = null;
    },
    // updateProduct
    targetUpdated: (state, action) => {
      state.error = null;
      state.actionsLoading = false;
      state.pageEntities.target = state.pageEntities.target.map(entity => {
        if (entity.target_id === action.payload.target.target_id) {
          return action.payload.target;
        }
        return entity;
      });
    },
  },
});
